module.exports = __webpack_public_path__ + "static/img/mly-product.0e5d452.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mly-product.png
// module id = Bj1y
// module chunks = 0